import React from 'react';

import { useIntl } from 'react-intl';

import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { queryClient } from 'src/lib/react-query';
import { toast } from 'src/hooks/useToast';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';
import ServicePlanTermFormModal from 'src/features/servicePlanTerms/components/forms/ServicePlanTermFormModal';
import { LIST_SERVICE_PLAN_TERMS_RESOURCE } from 'src/features/servicePlanTerms/api/useListServicePlanTerms';
import { servicePlanTermsMessages } from 'src/features/servicePlanTerms/utils/messages';
import { useParams } from 'react-router-dom';
import { SERVICE_PLAN_RESOURCE } from 'src/features/servicePlans/api/useGetServicePlan';
import { usePatchServicePlanTerm } from 'src/features/servicePlanTerms/api/usePatchServicePlanTerm';

interface UpdateServicePlanTermFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanTerm: ServicePlanTerm;
    children?: React.ReactNode;
}

function UpdateServicePlanItemFormModal<TData>({
    className,
    semantics,
    children,
    selectedServicePlanTerm,
}: UpdateServicePlanTermFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { servicePlanId = '' } = useParams();

    const { mutate, isPending } = usePatchServicePlanTerm({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_TERMS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [SERVICE_PLAN_RESOURCE] });
            toast({
                title: formatMessage(servicePlanTermsMessages.updateServicePlanTermSuccess),
                description: formatMessage(servicePlanTermsMessages.updateServicePlanTermSuccessDescription),
            });
        },
    });

    return (
        <ServicePlanTermFormModal
            selectedServicePlanTerm={selectedServicePlanTerm}
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, termId: selectedServicePlanTerm.id, servicePlanId }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.EDIT}
            isPending={isPending}
            subtitle={formatMessage(servicePlanTermsMessages.editServicePlanTermSubtitle)}
        >
            {children}
        </ServicePlanTermFormModal>
    );
}

export default UpdateServicePlanItemFormModal;
